import { render, staticRenderFns } from "./ResourceFilter.vue?vue&type=template&id=017067ea&"
import script from "./ResourceFilter.vue?vue&type=script&lang=js&"
export * from "./ResourceFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports